module.exports = __webpack_public_path__ + "b38f9b08.svg";